import { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup } from 'reactstrap';
import { useForm } from "react-hook-form"
import axios from 'axios';
import useToken from '../../useToken';


export const CategoriesAdd = ({ refetch, ...args }) => {
    const [modal, setModal] = useState(false);
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const { token } = useToken();


    const toggle = () => {
        setModal(!modal);
    }
    const addCategories = async (data) => {
        const response = await axios.post(`/api/categories`, data, {
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                Authorization: "Bearer " + token
            }
        })

        if (response.status >= 200 || response.status <= 204) {
            console.log(data)
            setModal(false)
            refetch()
            reset()
            console.log(response.data)
        }
    }

    return (
        <div>
            <Button className='mb-2' color="success" size="sm" onClick={toggle}>
                Добавить
            </Button>
            <Modal isOpen={modal} toggle={toggle} {...args}>
                <form onSubmit={handleSubmit(addCategories)}>
                    <ModalHeader toggle={toggle}>Создать пользователя</ModalHeader>
                    <ModalBody>
                        <div className="mb-3">
                            <label htmlFor="name" className="form-label">Название</label>
                            <input id="name" name="name" placeholder="Укажите Название" type="string" className="form-control"
                                {...register("name", {
                                    required: { value: true, message: "Поле \"Название\" не может быть пустым" }
                                })} />
                            {errors.name && <span className='text-danger'>{errors.name?.message}</span>}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <ButtonGroup>
                            <Button color="success">
                                Добавить
                            </Button>
                            <Button color="warning" onClick={() => {
                                toggle()
                                reset()
                            }}>
                                Отмена
                            </Button>
                        </ButtonGroup>
                    </ModalFooter>
                </form>
            </Modal>
        </div>
    )

}